/**
 * Normalize a URL pathname for comparison by removing trailing slashes, so
 * `/crm` and `/crm/` are treated as the same route. The root path `/` is
 * preserved. Use this whenever comparing the current location against a menu
 * or route path for active-state detection.
 */
export function normalizePathname(pathname: string): string {
  if (pathname.length <= 1) return pathname;
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}
